import { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  TemplateCategoryMasterDto,
  TemplateCategoryMasterUpdateRequestDto,
} from "@/dto/TemplateCategoryDto";

interface UseCategoryEditDialogProps {
  selectedCategory: TemplateCategoryMasterDto | null;
  onSubmit: (data: TemplateCategoryMasterUpdateRequestDto) => Promise<boolean>;
}

export const useCategoryEditDialog = ({
  selectedCategory,
  onSubmit,
}: UseCategoryEditDialogProps) => {
  // 수정 폼 초기화
  const editForm = useForm<TemplateCategoryMasterUpdateRequestDto>({
    defaultValues: {
      categoryName: "",
      categoryDesc: "",
      dispOrder: 0,
      demoPageUrl: "",
      anchorId: "",
      locationDesc: "",
      screenshotUrl: "",
    },
  });

  // 선택된, 카테고리가 변경될 때마다 폼 초기화
  useEffect(() => {
    if (!selectedCategory) return;

    editForm.reset({
      categoryName: selectedCategory.categoryName || "",
      categoryDesc: selectedCategory.categoryDesc || "",
      dispOrder: Number(selectedCategory.dispOrder) || 0,
      demoPageUrl: selectedCategory.demoPageUrl || "",
      anchorId: selectedCategory.anchorId || "",
      locationDesc: selectedCategory.locationDesc || "",
      screenshotUrl: selectedCategory.screenshotUrl || "",
    });
  }, [selectedCategory, editForm]);

  // 폼 제출 핸들러
  const handleSubmit = async (data: TemplateCategoryMasterUpdateRequestDto) => {
    if (!selectedCategory) return false;

    try {
      const updateData = {
        ...data,
        masterCategoryId: Number(selectedCategory.masterCategoryId),
        // 숫자 필드 명시적 변환
        dispOrder: Number(data.dispOrder),
      };

      console.log("카테고리 수정 요청 데이터:", updateData);

      return await onSubmit(updateData);
    } catch (error) {
      console.error("카테고리 수정 에러 (다이얼로그 내부):", error);
      return false;
    }
  };

  return {
    editForm,
    handleSubmit: editForm.handleSubmit(handleSubmit),
  };
};
